// This file will build the plugin

import Tip from './components/Tip'

import './styles/plugin.scss'

export default Tip

export { Tip }



// WEBPACK FOOTER //
// ./src/index.js